document.addEventListener('DOMContentLoaded', initJourneyTimelineNkten);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initJourneyTimelineNkten);
}

function initJourneyTimelineNkten(event) {
  const root = event && event.target && event.target.querySelector
    ? event.target.querySelector('[data-journey-timeline-nkten]')
    : document.querySelector('[data-journey-timeline-nkten]');

  const sections = root
    ? [root]
    : document.querySelectorAll('[data-journey-timeline-nkten]');

  sections.forEach((section) => {
    if (!section || section.dataset.journeyInitialized) return;
    section.dataset.journeyInitialized = 'true';

    const track = section.querySelector('[data-journey-track]');
    const cards = Array.from(section.querySelectorAll('[data-journey-card]'));
    const dots = Array.from(section.querySelectorAll('[data-journey-dot]'));

    if (!track || cards.length === 0) return;

    let activeIndex = 0;
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let dragMoved = false;

    // Prevent the scroll event from changing the active card
    // while we are programmatically scrolling to a card.
    let isProgrammaticScroll = false;
    let programmaticScrollTimeout;

    const setActive = (index) => {
      if (index < 0 || index >= cards.length) return;

      activeIndex = index;

      cards.forEach((card, i) => {
        const isActive = i === index;

        card.classList.toggle('is-active', isActive);
        card.setAttribute(
          'aria-current',
          isActive ? 'true' : 'false'
        );
      });

      dots.forEach((dot, i) => {
        const isActive = i === index;

        dot.classList.toggle('is-active', isActive);
        dot.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });
    };

    const closestCardIndex = () => {
      const trackCenter =
        track.scrollLeft + track.clientWidth / 2;

      let closest = 0;
      let closestDistance = Infinity;

      cards.forEach((card, i) => {
        const cardCenter =
          card.offsetLeft + card.offsetWidth / 2;

        const distance = Math.abs(cardCenter - trackCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closest = i;
        }
      });

      return closest;
    };

    /*
     * Scroll to a specific card.
     *
     * We keep the active index locked during the smooth scroll,
     * so the scroll event cannot accidentally activate card +1.
     */
    const goToCard = (index) => {
      if (index < 0 || index >= cards.length) return;

      clearTimeout(programmaticScrollTimeout);

      isProgrammaticScroll = true;

      // Set the correct active state immediately.
      setActive(index);

      const card = cards[index];

      track.scrollTo({
        left: card.offsetLeft,
        behavior: 'smooth'
      });

      /*
       * Wait until the smooth scroll has finished before allowing
       * normal scroll detection again.
       */
      programmaticScrollTimeout = setTimeout(() => {
        isProgrammaticScroll = false;

        // Keep the requested card active.
        setActive(index);
      }, 600);
    };

    let scrollTimeout;

    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);

      // Don't let programmatic scrolling change the active card.
      if (isProgrammaticScroll) return;

      scrollTimeout = setTimeout(() => {
        if (!isProgrammaticScroll) {
          setActive(closestCardIndex());
        }
      }, 100);
    });

    /*
     * Dot navigation
     */
    dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        goToCard(i);
      });
    });

    /*
     * Drag / mouse / touch navigation
     */
    track.addEventListener('pointerdown', (e) => {
      isDown = true;
      dragMoved = false;

      // User is manually scrolling now.
      isProgrammaticScroll = false;
      clearTimeout(programmaticScrollTimeout);

      track.classList.add('is-dragging');

      startX = e.clientX;
      scrollLeft = track.scrollLeft;

      // Helps prevent pointer interactions from escaping.
      if (track.setPointerCapture) {
        try {
          track.setPointerCapture(e.pointerId);
        } catch (error) {
          // Ignore pointer capture errors.
        }
      }
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;

      const delta = e.clientX - startX;

      if (Math.abs(delta) > 5) {
        dragMoved = true;
      }

      track.scrollLeft = scrollLeft - delta;
    });

    const endDrag = () => {
      if (!isDown) return;

      isDown = false;
      track.classList.remove('is-dragging');

      /*
       * After manual dragging, determine the card that is actually
       * closest to the center.
       */
      setActive(closestCardIndex());
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);

    /*
     * Prevent clicking a card/link after dragging.
     */
    track.addEventListener('click', (e) => {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();

        dragMoved = false;
      }
    });

    /*
     * Keyboard navigation
     */
    track.addEventListener('keydown', (e) => {
      if (
        e.key === 'ArrowRight' &&
        activeIndex < cards.length - 1
      ) {
        e.preventDefault();

        goToCard(activeIndex + 1);

      } else if (
        e.key === 'ArrowLeft' &&
        activeIndex > 0
      ) {
        e.preventDefault();

        goToCard(activeIndex - 1);
      }
    });

    // Set initial state.
    setActive(0);
  });
}